<template>
  <div class="flex w-full items-center">
    <QrTableSearchField
      v-if="screens.md"
      class="w-80 rounded-lg"
      :placeholder="$t('dashboard.search.hint')" />

    <div v-else class="flex items-center w-full gap-2 justify-end">
      <span class="font-semibold px-1">{{ $t("navigation.content.label") }}</span>
      <AddButton :label="$t('component.button.create.cta')" @click="ctaHandler" />
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect } from "vue"
import { useRoute, useRouter } from "vue-router"
import { ApGrid } from "@Mobile-Leaves-CORP/ap-components"
import QrTableSearchField from "./QrTable/QrTableSearchField.vue"
import CreateQrHandler from "@/handlers/Qrs/CreateQrHandler.js"
import AddButton from "@/components/Buttons/AddButton.vue"

const route = useRoute()
const router = useRouter()
const screens = ApGrid.useBreakpoint()
const headerTitle = ref("")

watchEffect(() => (headerTitle.value = route.name))

function ctaHandler() {
  CreateQrHandler.render(router)
}
</script>
